import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import AppContext from '../context/AppContext';

import CloseIcon from '@mui/icons-material/Close';

import { create } from 'ipfs-http-client';

import useApi from '../hooks/useApi';
import createpostApi from '../api/createpost';

import { Loader } from './index';

/* Create an instance of the client */

const CreateShort = ({ show, onClose, disconnect, account }) => {
  const { theme, accountDetails } = useContext(AppContext);
  const [text, setText] = useState('');

  const [video, setVideo] = useState();
  const hiddenFileInput = React.useRef(null);
  const videoShown = React.useRef(null);
  const createPost = useApi(createpostApi.createPost);

  const handleClick = event => {
    hiddenFileInput.current.click();
  };
  const uploadFileHandler = async e => {
    const file = e.target.files[0];
    console.log('This is the file', file);
    if (file?.type.startsWith('video')) {
      setVideo(
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
    } else {
    }
  };
  const submitHandler = async () => {
    if (!text) {
      alert('Write what your short is about');
      return;
    }
    try {
      if (video) {
        let API_TOKEN = process.env.REACT_APP_LIVEPEER_TOKEN;
        let config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${API_TOKEN}`,
            withCredentials: true,
            credentials: 'include',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods':
              'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers':
              'Origin, Content-Type, X-Auth-Token, Authorization, Accept,charset,boundary,Content-Length',
          },
        };

        const { data } = await axios.post(
          `https://livepeer.com/api/asset/request-upload`,
          { name: text || 'A Short for SpeakOut' },
          config
        );
        console.log(data, 'DATA FROM LIVE PEER');
        config = {
          headers: {
            'Content-Type': 'video/mp4',
            withCredentials: true,
            credentials: 'include',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods':
              'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers':
              'Origin, Content-Type, X-Auth-Token, Authorization, Accept,charset,boundary,Content-Length',
          },
        };
        await axios.put(data.url, video, config);

        config = {
          headers: {
            Authorization: `Bearer ${API_TOKEN}`,
            withCredentials: true,
            credentials: 'include',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods':
              'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers':
              'Origin, Content-Type, X-Auth-Token, Authorization, Accept,charset,boundary,Content-Length',
          },
        };
        const lastdata = await axios.get(
          `https://livepeer.com/api/asset/${data.asset.id}`,
          config
        );
        console.log('LIVEPEER VIDEO WILL BE HERE OOO', lastdata);

        const url = `https://cdn.livepeer.com/asset/${lastdata?.data?.playbackId}/video`;
        console.log('LIVEPEER VIDEO WILL BE HERE OOO', url);

        createPost.request(accountDetails?.id, {
          text,
          desc: 'A Short on SpeakOut Platform',
          video: { url, type: video.type },
        });
      } else {
        alert('Choose short');
      }
    } catch (error) {
      console.log('Error uploading file: ', error);
    }
  };

  useEffect(() => {
    if (createPost?.success) {
      alert('Short Created Successfully');

      setVideo();
      setText('');
      window.location.reload();
    }
    if (createPost?.error) {
      alert('Error creating short');
    }
  }, [createPost?.success, createPost?.error]);

  return (
    <StyledCreateShort theme_={theme}>
      <Loader visible={createPost.loading} />
      <div className="container">
        <textarea
          type="text"
          onChange={e => setText(e.target.value)}
          value={text}
          placeholder="What is this short about?"
          className="input-text"
        ></textarea>
        {video && (
          <span className="video">
            <button onClick={() => setVideo()} className="cancel">
              <CloseIcon />
            </button>
            <video controls autoPlay ref={videoShown}>
              <source src={video.preview} type="video/mp4" />
            </video>
          </span>
        )}

        <div className="footer">
          <button onClick={handleClick} className="upload">
            Choose Short
          </button>
          <span className="submit">
            <button onClick={submitHandler}>Create Short</button>
          </span>
        </div>
      </div>
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={uploadFileHandler}
        style={{ display: 'none' }}
      />
    </StyledCreateShort>
  );
};
const StyledCreateShort = styled.div`
  padding: 0rem 2rem;
  -moz-box-shadow: 0 0 3px #ccc;
  -webkit-box-shadow: 0 0 3px #ccc;
  box-shadow: 0 0 3px #ccc;
  clip-path: inset(0px 0px -15px 0px);
  @media screen and (max-width: 900px) {
    padding: 0rem 1rem;
  }
  .container {
    display: flex;
    flex-flow: column wrap;
    .error {
      color: red;
    }
    .input-text {
      background: inherit;
      border: none;
      font-size: 1.2rem;
      outline: none;
      padding-top: 1rem;
      resize: none;
      color: ${({ theme_ }) => (theme_ ? 'white' : 'black')};
      height: auto;
    }
    .video,
    .img {
      width: 100%;
      border-radius: 0.5rem;
      position: relative;
      overflow: hidden;
      margin-top: 0.5rem;
      video {
        width: 100%;
      }
      img {
        width: 100%;
      }
      transition: 2s ease-in-out;
      .cancel {
        padding: 0.5rem;
        border-radius: 0.5rem;
        position: absolute;
        top: 2%;
        left: 2%;
        z-index: 2;
        cursor: pointer;
        display: none;
        background-color: rgba(31, 32, 41, 0.75);
      }
      &:hover {
        .cancel {
          display: block;
        }
      }
    }
    .img {
    }
    .footer {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      padding: 1rem 0rem;
      button {
        font-size: 1.2rem;
      }
      .upload {
        background: inherit;
        color: #50c1e9;
        padding: 0rem;
      }
    }
  }
`;
export default CreateShort;
